import { Card, Grid, Typography } from '@material-ui/core'
import { hasPermission, Permissions } from 'Permissions'
import {
  ArrayField,
  Datagrid,
  FunctionField,
  NumberField,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  TopToolbar,
  usePermissions,
} from 'react-admin'

import FeasibilityStatButton from 'components/Common/FeasibilityStatButton'
import { CustomBooleanField } from 'components/Fields'

const CustomCTXLoadActions = ({ data }: any) => {
  const { permissions } = usePermissions()
  if (!data || !permissions) return null

  const canChangeFeasibilityStat =
    permissions && hasPermission(permissions, Permissions.CanChangeFeasibilityStat)
  return canChangeFeasibilityStat ? (
    <TopToolbar>
      <Grid container direction="row" spacing={2} justifyContent="flex-start">
        <Grid item>
          <FeasibilityStatButton kind="ctx_load" id={data.id} label="Start Feasibility Check" />
        </Grid>
      </Grid>
    </TopToolbar>
  ) : null
}

const CTXOnelineAddress = ({ record, ...props }: any) => {
  let address1 = record.location.address.address_1 ? `${record.location.address.address_1}, ` : ''
  let address2 = record.location.address.address_2 ? `${record.location.address.address_2}, ` : ''
  let fullAddress = `${address1}${address2}${record.location.address.city}, ${record.location.address.state_province} ${record.location.address.postal_code}`
  return (
    <Typography component="span" variant="body2" {...props}>
      {fullAddress}
    </Typography>
  )
}

const CTXLoadStops = ({ record, source }: any) => {
  return (
    <ArrayField record={record} source={source} label="Stops">
      <Datagrid>
        <NumberField source="auto_ordinal_index" label="Sequence Number" />
        <CustomBooleanField source="is_pickup" />
        <CustomBooleanField source="is_dropoff" />
        <TextField source="display_planned_window" />
        <TextField source="location.location_name" label="Location Name" />
        <CTXOnelineAddress record={record} label="Location address" />
      </Datagrid>
    </ArrayField>
  )
}

export const CTXLoadShow = (props: any) => {
  return (
    <Show actions={<CustomCTXLoadActions />} {...props}>
      <Grid container direction="column" spacing={3} alignItems="baseline" justifyContent="flex-start">
        <Grid item>
          <Card style={{ marginTop: '20px', paddingBottom: '20px' }}>
            <TabbedShowLayout record={props.record}>
              <Tab label="Load information">
                <TextField source="source_json.name" label="Name" />
                <TextField source="source_json.mode.description" label="Mode" />
                <TextField source="id" />
                <TextField source="source_id" label="Source Id" />
                <TextField source="human_id" label="Ref ID" />
                <TextField source="company_name" label="Company" />
                <TextField source="source_tms" label="Source TMS" />
                <TextField source="ctx_status" label="Status" />
                <CTXLoadStops source="stops" record={props.record} />
                <TextField source="trip_rate" />
                <NumberField source="trip_distance_mi" />
              </Tab>
              <Tab label="Equipment">
                <TextField source="equipment[0]" label="Equipment" />
                <TextField source="source_json.equipment_type.name" label="Type" />
                <TextField source="truck_full_load" />
                <NumberField source="truck_weight_lb" />
                <NumberField source="truck_length_ft" />
              </Tab>
              <Tab label="Misc" path="misc">
                <NumberField source="stops.length" label="Stops" />
                <TextField source="origin_location" />
                <TextField source="dest_location" />
              </Tab>
              <Tab label="Metadata">
                <FunctionField
                  label="Raw Data Received"
                  render={(record: any) => {
                    const prettyRawData = JSON.stringify(record.source_json, null, 2)
                    return <pre>{prettyRawData}</pre>
                  }}
                />
              </Tab>
            </TabbedShowLayout>
          </Card>
        </Grid>
      </Grid>
    </Show>
  )
}
